
export default new class resourcesPopup {

  init() {
    console.log('resourcesPopup page loaded');

    var overlay = document.querySelector('.overlay');
    var resourceRows = document.querySelectorAll('.resources');

    resourceRows.forEach(function (resourceRow) {
      var closeButtons = resourceRow.querySelectorAll('.close-button');
      var popupButtons = resourceRow.querySelectorAll('.popup-button');

      popupButtons.forEach(function (popupButton) {
        popupButton.addEventListener('click', function () {
          var index = this.getAttribute('data-popup-index');
          var sectionId = this.getAttribute('data-section-id');
          var section = document.getElementById(sectionId);
          var popup = section.querySelector('.popup[data-popup-index="' + index + '"]');

          overlay.style.display = 'block';
          popup.style.display = 'block';

          // Change background color of the specific section
          if(sectionId === 'get-beta') {
            section.style.backgroundColor = '#d4c1ff';
          } 
          else if (sectionId === 'examined-life') {
            section.style.backgroundColor = '#abd2ff';
          } 
          else if (sectionId === 'story') {
            section.style.backgroundColor = '#b3dad2';
          } 
          else if (sectionId === 'get-out') {
            section.style.backgroundColor = '#c8d4dc';
          } 
          else if (sectionId === 'elections') {
            section.style.backgroundColor = '#e6cbc5';
          } 
          else if (sectionId === 'solution') {
            section.style.backgroundColor = '#abd2ff';
          } 
        });
      });

      closeButtons.forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
          var sectionId = this.getAttribute('data-section-id');
          var section = document.getElementById(sectionId);
          var popup = this.closest('.popup');

          if (popup && window.getComputedStyle(popup).display !== 'none') {
            popup.style.display = 'none';
            overlay.style.display = 'none';

            // Remove background color of the specific section
            section.style.backgroundColor = '#f2f2f2';
          }
        });
      });
    });
  }
}

